import type { RouteRecordRaw } from 'vue-router'
import { schedulerRoutes } from '@/routes/Public/scheduler.routes'
import { unsubscribeRoutes } from '@/routes/Public/unsubscribe.routes'

const publicRoutes: RouteRecordRaw[] = [...unsubscribeRoutes, ...schedulerRoutes]

export default publicRoutes
